import { createApiSlice } from "@common";
import {
  CRUD_OAUTH,
  GET_OAUTH_BY_INTEGRATION,
  GET_OAUTH_CONNECT_URL,
  GET_OAUTH_DETAILS,
  GET_OAUTH_KEY,
  GET_OAUTH_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addOAuthIntegration",
    method: "post",
    url: CRUD_OAUTH,
    stateKey: "message",
  },
  {
    name: "getOAuthByIntegration",
    method: "get",
    url: GET_OAUTH_BY_INTEGRATION,
    stateKey: "data",
  },
  {
    name: "getOAuthIntegrationDetails",
    method: "get",
    url: GET_OAUTH_DETAILS,
    stateKey: "details",
  },
  {
    name: "updateOAuthIntegration",
    method: "put",
    url: CRUD_OAUTH,
    stateKey: "message",
  },
  {
    name: "deleteOAuthIntegration",
    method: "delete",
    url: CRUD_OAUTH,
    stateKey: "message",
  },
  {
    name: "updateOAuthIntegrationStatus",
    method: "patch",
    url: GET_OAUTH_STATUS,
    stateKey: "message",
  },
  {
    name: "getOAuthConnectUrl",
    method: "post",
    url: GET_OAUTH_CONNECT_URL,
    stateKey: "message",
  },
  {
    name: "getOAuthPublicCertificateKey",
    method: "get",
    url: GET_OAUTH_KEY,
    stateKey: "keyData",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
    urlData: [],
    keyData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "oAuth",
  apiConfig,
  customReducers,
);
const oAuthSlice = slice;
// Export the slice's reducer
export default oAuthSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  getOAuthIntegrationDetails,
  addOAuthIntegration,
  getOAuthByIntegration,
  updateOAuthIntegration,
  deleteOAuthIntegration,
  updateOAuthIntegrationStatus,
  getOAuthConnectUrl,
  getOAuthPublicCertificateKey
} = thunks;

// Destructure and export actions 
export const { rowSelect } =
  actions;
